import axios from 'axios';
import { HOST } from 'configs/host';

export const Api = axios.create({
  baseURL: `${HOST.API.URL}/${HOST.API.API_PREFIX}`,
  headers: {
    common: {
      'x-api-key': 'EjCn1MwSsm8MESe82sZ8faKopTy7lrCI2YkHtHk8',
    },
  },
});
